import AxiosClient from "../AxiosClient";

// 取引先送信グループ取得Api
export const postCustomerSendingGroupSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/customerSendingGroup/searchInfoList", params);
}
